import React, { useState, useEffect } from "react";
import { loginAdmin } from "../actions/adminActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "../css/login.css";

const LoginScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const adminLogin = useSelector((state) => state.adminLogin);
  const { admin, loading, error } = adminLogin || {};

  useEffect(() => {
    if (admin?.token) {
      const redirectTo = location.state?.from?.pathname || "/";
      navigate(redirectTo, { replace: true });
    }
  }, [admin]);

  const login = (e) => {
    e.preventDefault();
    dispatch(loginAdmin(email, password));
  };

  return (
    <div className="login-page">
      <div className="login-branding">
        <img
          src="../images/white.png"
          className="login-branding-logo"
          alt="EMotorad"
        />
        <p className="login-branding-tagline">
          Manage orders, warranty, products and stores from one console.
        </p>
      </div>

      <div className="login-panel">
        <div className="login-card">
          <h1 className="login-title">Welcome back</h1>
          <p className="login-subtitle">Sign in to your admin account</p>

          {error && <div className="login-error">{error}</div>}

          <form onSubmit={login} className="login-form">
            <div className="form-floating mb-3">
              <input
                type="email"
                className="form-control"
                id="loginEmail"
                required
                autoComplete="username"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                placeholder="name@example.com"
              />
              <label htmlFor="loginEmail">Email address</label>
            </div>

            <div className="form-floating login-password-field mb-3">
              <input
                type={showPassword ? "text" : "password"}
                required
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                className="form-control"
                id="loginPassword"
                placeholder="Password"
              />
              <label htmlFor="loginPassword">Password</label>
              <button
                type="button"
                className="login-password-toggle"
                onClick={() => setShowPassword((v) => !v)}
                tabIndex={-1}
              >
                <i
                  className={`fa-solid ${
                    showPassword ? "fa-eye-slash" : "fa-eye"
                  }`}
                ></i>
              </button>
            </div>

            <button
              type="submit"
              className="btn login-submit-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <i className="fa-solid fa-spinner fa-spin me-2"></i>
                  Signing in...
                </>
              ) : (
                "Sign in"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
